import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

@Entity()
export class ContactPerson extends MongoEntity {
  static override _class = 'ContactPerson';
  static override _collectionName = 'contact-persons';

  // Relation to Company / SAP partner identification
  @Field(() => String) debitor: Maybe<string>;
  @Field(() => String) partner: Maybe<string>;

  // SAP sales structure
  @Field(() => String) salesOrg: Maybe<string>;
  @Field(() => String) salesOffice: Maybe<string>;
  @Field(() => String) role: Maybe<string>;

  // Person
  @Field(() => String) firstName: Maybe<string>;
  @Field(() => String) lastName: Maybe<string>;
  @Field(() => String) email: Maybe<string>;

  // Company snapshot from the source XLSX
  @Field(() => String) companyName: Maybe<string>;
  @Field(() => String) companyName2: Maybe<string>;
  @Field(() => String) countryCode: Maybe<string>;
  @Field(() => String) city: Maybe<string>;
  @Field(() => String) zipCode: Maybe<string>;

  constructor(data: Partial<ContactPerson>) {
    super(data);
    Object.assign(this, data);
  }
}
